import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getUser } from '../../services/auth'; // Importe o seu serviço de autenticação

const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props =>
                getUser() ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/" />
                )
            }
        />
    );
};

export default PrivateRoute;
